import { Button, Form } from 'antd';
import type { FormInstance } from 'rc-field-form';

import type { ExperienceBulkEditFormValues } from 'app/typings/core/extranet/experiences/experienceBulkEdit';

import styles from '../ExperienceBulkEdit.module.scss';

type ExperienceBulkEditFooterProps = {
  handleClose: () => void;
  form: FormInstance<ExperienceBulkEditFormValues>;
};

export const ExperienceBulkEditFooter = ({
  handleClose,
  form,
}: ExperienceBulkEditFooterProps) => {
  const isDisabled =
    !form.isFieldsTouched(['startDate', 'endDate'], true) ||
    !!form.getFieldsError().filter(({ errors }) => errors.length).length;

  return (
    <div className={styles.bulkEditFooter}>
      <Form.Item shouldUpdate>
        {() => (
          <>
            <Button size="large" type="ghost" onClick={handleClose} key="back">
              Cancel
            </Button>
            <Button
              key="save"
              size="large"
              type="primary"
              htmlType="submit"
              disabled={isDisabled}
            >
              Save
            </Button>
          </>
        )}
      </Form.Item>
    </div>
  );
};
